import card_index from '../card_index';

export function getImage(id: string) {
  const image = new Image();
  image.src = require(`!url-loader!../../public/images/cards/${id.toLocaleLowerCase()}.png`);
  return image;
}

function imageLoader() {
  const imagesMap: any = {};

  for (const i in card_index) {
    const _card = card_index[i];
    const { id } = _card;
    imagesMap[card_index[i].name] = getImage(id);
  }

  return imagesMap;
}

export default imageLoader;
